const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
        lg: { span: 6 },
        xl: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        lg: { span: 18 },
        xl: { span: 18 },
    },
};

export default formItemLayout;


// WEBPACK FOOTER //
// ./src/const/form/formItemLayout.js